var AuthorizedRoute = require('../mixins/authorized-route')
var Scope = require('../utils/scope')

module.exports = Em.Route.extend(AuthorizedRoute, {
    userOrganizations: Em.inject.service(),

    organization: Em.computed.alias('userOrganizations.activeOrganization'),

    scopes: function() {
        var organization = this.get('organization')
        var isSourceZervant = organization.get('isSourceZervant')

        if (!isSourceZervant) {
            return [Scope.ProductRead]
        }

        /**
         * TODO: When we give 'Scope.ProductRead' scope to all zervant users,
         *  just return [Scope.ProductRead] for scopes and not a function
         */
        return []
    }.property('organization')
})
